const collator = new Intl.Collator('es', { sensitivity: 'base' });

export function cityKey(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

/** Misma normalización que ciudad: sirve para zona / barrio. */
export function zoneKey(value) {
  return cityKey(value);
}

export function sameCity(a, b) {
  const ka = cityKey(a);
  const kb = cityKey(b);
  return Boolean(ka && kb && ka === kb);
}

export function sameZone(a, b) {
  const ka = zoneKey(a);
  const kb = zoneKey(b);
  return Boolean(ka && kb && ka === kb);
}

export function matchSucursalText(s, term) {
  if (!term) return true;
  const hay = [s.codigo, s.nombre, s.ciudad, s.zona, s.direccion, s.documento, s.telefono1, s.telefono2]
    .filter(Boolean)
    .join(' ')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  return hay.includes(term);
}

export function normalizeSearchTerm(q) {
  return String(q || '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

export function uniqueCities(rows) {
  const map = new Map();
  for (const s of rows || []) {
    const name = String(s.ciudad || '').trim();
    if (!name) continue;
    const key = cityKey(name);
    if (!map.has(key)) map.set(key, name);
  }
  return [...map.values()].sort(collator.compare);
}

export function uniqueZonas(rows, ciudad = '') {
  const map = new Map();
  for (const s of rows || []) {
    if (ciudad && !sameCity(s.ciudad, ciudad)) continue;
    const name = String(s.zona || '').trim();
    if (!name) continue;
    const key = zoneKey(name);
    if (!map.has(key)) map.set(key, name);
  }
  return [...map.values()].sort(collator.compare);
}

export function filterSucursales(rows, { q = '', ciudad = '', zona = '' } = {}) {
  const term = normalizeSearchTerm(q);
  return (rows || [])
    .filter(
      (s) =>
        (!ciudad || sameCity(s.ciudad, ciudad)) &&
        (!zona || sameZone(s.zona, zona)) &&
        matchSucursalText(s, term)
    )
    .sort((a, b) => collator.compare(a.nombre || '', b.nombre || ''));
}
